import React from 'react';
import { X, Database, CheckCircle, Cpu, TrendingUp, Target, Clock, Activity, Star, Eye, Download } from 'lucide-react';
import { modalStyles } from '../../styles/modalStyles';

const AgentDetailModal = ({ selectedAgent, onClose }) => {
  if (!selectedAgent) return null;

  return (
    <div style={modalStyles.modalOverlay} onClick={onClose}>
      <div style={modalStyles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={modalStyles.modalHeader}>
          <div>
            <h2 style={modalStyles.modalTitle}>{selectedAgent.name}</h2>
            <div style={modalStyles.modalCategory}>{selectedAgent.category}</div>
          </div>
          <button 
            style={modalStyles.closeButton}
            onClick={onClose}
          >
            <X size={20} />
          </button>
        </div>

        <div style={modalStyles.modalContent}>
          {/* Description */}
          <div style={modalStyles.modalSection}>
            <h3 style={modalStyles.modalSectionTitle}>
              <Database size={18} />
              Overview
            </h3>
            <p style={{ color: '#cccccc', lineHeight: 1.6, marginBottom: '16px' }}>
              {selectedAgent.longDescription}
            </p>
            <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap', fontSize: '14px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Clock size={16} style={{ color: '#8b5cf6' }} />
                <span>Setup: {selectedAgent.setupTime}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Activity size={16} style={{ color: '#8b5cf6' }} />
                <span>Updated: {selectedAgent.lastUpdated}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Star size={16} style={{ color: '#f59e0b' }} />
                <span>{selectedAgent.popularity}/5 ({selectedAgent.downloads.toLocaleString()} downloads)</span>
              </div>
            </div>
          </div>

          {/* Features */}
          {selectedAgent.features && (
            <div style={modalStyles.modalSection}>
              <h3 style={modalStyles.modalSectionTitle}>
                <CheckCircle size={18} />
                Key Features
              </h3>
              <div style={modalStyles.featureList}>
                {selectedAgent.features.map((feature, index) => (
                  <div key={index} style={modalStyles.featureItem}>
                    <CheckCircle size={14} style={{ color: '#10b981', flexShrink: 0 }} />
                    <span style={{ color: '#d1d5db' }}>{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Technical Specifications */}
          {selectedAgent.techSpecs && (
            <div style={modalStyles.modalSection}>
              <h3 style={modalStyles.modalSectionTitle}>
                <Cpu size={18} />
                Technical Specifications
              </h3>
              <div style={modalStyles.techSpecsGrid}>
                {Object.entries(selectedAgent.techSpecs).map(([key, value]) => (
                  <div key={key} style={modalStyles.techSpecItem}>
                    <div style={modalStyles.techSpecLabel}>{key}</div>
                    <div style={modalStyles.techSpecValue}>{value}</div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Usage Statistics */}
          {selectedAgent.usageStats && (
            <div style={modalStyles.modalSection}>
              <h3 style={modalStyles.modalSectionTitle}>
                <TrendingUp size={18} />
                Usage Statistics
              </h3>
              <div style={modalStyles.statsGrid}>
                {Object.entries(selectedAgent.usageStats).map(([key, value]) => (
                  <div key={key} style={modalStyles.statItem}>
                    <div style={modalStyles.statValue}>{value}</div>
                    <div style={modalStyles.statLabel}>{key}</div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Tags & Industries */}
          <div style={modalStyles.modalSection}>
            <h3 style={modalStyles.modalSectionTitle}>
              <Target size={18} />
              Tags & Industries
            </h3>
            <div style={{ marginBottom: '16px' }}>
              <div style={{ fontSize: '14px', color: '#9ca3af', marginBottom: '8px' }}>Technologies:</div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                {selectedAgent.tags.map((tag, index) => (
                  <span key={index} style={{
                    fontSize: '12px',
                    padding: '4px 8px',
                    background: 'rgba(124, 58, 237, 0.1)',
                    border: '1px solid rgba(124, 58, 237, 0.3)',
                    borderRadius: '12px',
                    color: '#d1d5db'
                  }}>
                    {tag}
                  </span>
                ))}
              </div>
            </div>
            {selectedAgent.industries && (
              <div>
                <div style={{ fontSize: '14px', color: '#9ca3af', marginBottom: '8px' }}>Industries:</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                  {selectedAgent.industries.map((industry, index) => (
                    <span key={index} style={{
                      fontSize: '12px',
                      padding: '4px 8px',
                      background: 'rgba(16, 185, 129, 0.1)',
                      border: '1px solid rgba(16, 185, 129, 0.3)',
                      borderRadius: '12px',
                      color: '#d1d5db'
                    }}>
                      {industry}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>

        <div style={modalStyles.modalFooter}>
          <button style={{ ...modalStyles.modalButton, ...modalStyles.secondaryModalButton }}>
            <Eye size={16} />
            Live Demo
          </button>
          <button style={{ ...modalStyles.modalButton, ...modalStyles.primaryModalButton }}>
            <Download size={16} />
            Deploy Agent
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgentDetailModal;